module.exports = __webpack_public_path__ + "../resources/img/ic-re-show-bg-default.a37380c6.svg";